
    {{ election.name }}
  